import { PLAYABLE_EXTERNAL_CLAIM } from 'constants/api'
import axios from 'axios'
import ExchangeComponent from 'components/exchange'
import LoadingScreen from 'components/loading-screen'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import textServices from 'services/text-services'
import { Prize } from 'views/prizes/types'

type ClaimPrize = Prize & {
  points?: number
  stickerId?: number
  couponTypeId?: number
  prizeNumber?: number
}

const GameClaim = () => {
  const [{ data: session, user }] = useSession()
  const { match } = useRouter()
  const history = useHistory()
  const [prize, setPrize] = useState<ClaimPrize | null>(null)

  const gameId = match?.params?.gameId as string

  useEffect(() => {
    const claimGame = async () => {
      if (!gameId) {
        history.push('/ranking')
        return
      }

      if (!session) return

      try {
        const { data } = await axios.post(
          PLAYABLE_EXTERNAL_CLAIM.replace(':gameId', gameId),
          null,
          {
            headers: {
              Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`,
              'Ph-Api-Id': PH_API_ID ?? 1
            }
          }
        )

        if (data?.prize) {
          setPrize(data?.prize)
          return
        }

        history.push('/ranking')
      } catch (error) {
        history.push('/ranking')
      }
    }

    claimGame()
  }, [])

  if (prize) {
    return (
      <ExchangeComponent
        title={`¡${user?.firstName},Tienes ${prize.title}! Canjéala en Uber Eats`}
        buttons={{
          handleMenu: () => window.open('https://www.ubereats.com/feed?promoCode= mx_heineken_30off_gaming_2026_apr_solmezclas&mod=applyPromo'),
          handleButtonCommon: () => window.open('https://www.ubereats.com/feed?promoCode= mx_heineken_30off_gaming_2026_apr_solmezclas&mod=applyPromo'),
          handleButtonSticker: () => window.open('https://www.ubereats.com/feed?promoCode= mx_heineken_30off_gaming_2026_apr_solmezclas&mod=applyPromo'),
          text: textServices.findByText('game/claim/exchange/button', { es: 'QUIERO MI SOL CLAMATO', en: 'QUIERO MI SOL CLAMATO' })
        }}
        item={prize}
        module="login"
      />
    )
  }

  return <LoadingScreen />
}

export default GameClaim
